<template>
  <div class="page-content">
    <page-template ref="deliverTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :detailColumns="detailColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import date from '@/mixin/date'

  export default {
    mixins: [date],
    components: {
      pageTemplate
    },
    data() {
      return {
        // 高级搜索条件
        searchOptions: {
          simple: [{label: '业务单号', prop: 'orderNo', type: 'input', isFuzzy: true, placeholder: '请输入业务单号'}],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              // defaultValue: '10',
              span: 24
            },
            // {
            //   label: '调拨级别',
            //   type: 'select',
            //   prop: 'relateType',
            //   data: this.$utils.getCacheStatus('dnRequireOrder.relateType'),
            //   span: 12,
            //   change: this.selectLevel
            // },
            {
              label: '调出门店',
              type: 'select',
              prop: 'distributionStoreId',
              data: [],
              span: 12,
              isHasAll: true,
              url: api.system.seStore,
            },
            {
              label: '调入门店',
              type: 'select',
              prop: 'receivingStoreId',
              data: [],
              span: 12,
              isHasAll: true,
              url: api.system.seStore,
              defaultValue: this.$utils.getSysUser().storeId,
              hidden: this.$utils.getSysUser().storeId === null ? false : true
            },
            {
              label: '审核状态',
              prop: 'auditStatus',
              type: 'select',
              defaultValue: 10,
              data: [{label: '未审核', value: 10}, {label: '已审核', value: 20}],
              span: 12,
            },
            {
              label: '收货状态',
              prop: 'receivingStatus',
              type: 'select',
              data: this.$utils.getCacheStatus('dnAllocationOrder.receivingStatus')
            }]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
            callback: this.addRequisition
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.toEditPage,
            filter: (data) => {
              return data.auditStatus == 10 ? true : false;
            },
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
            filter: (data) => {
              return false;
            }
          },
          {
            label: '导出',
            code: 'export',
            callback: this.goodsDetailExport,
            filter: () => {
              return false
            }
          }
        ],
        // 表格信息配置
        tableOptions: {
          tableName: 'clearTable',
          indexShow: true,//是否显示索引
          showSelect: true,
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              width: '240',
              align: 'center',
              // showDetail: true
              callback: this.goOrderDetail
            },
            {
              label: '审核状态',
              prop: 'auditStatus',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('dnDistributionOrder.auditStatus')
            },
            {
              label: '调出门店',
              prop: 'distributionStoreName',
              width: '250',
              align: 'center'
            },
            {
              label: '调入门店',
              prop: 'receivingStoreName',
              width: '250',
              align: 'center'
            },
            {
              label: '单据金额(元)',
              prop: 'billAmount',
              width: '120',
              align: 'center',
              deal: this.$utils.returnFloat
            },
            {
              label: '制单人',
              prop: 'voucherName',
              width: '120',
              align: 'center'
            },
            {
              label: '制单日期',
              prop: 'voucherDttm',
              width: '150',
              align: 'center'
            },
            {
              label: '审核人',
              prop: 'reviewerName',
              width: '120',
              align: 'center'
            },
            {
              label: '审核日期',
              prop: 'reviewerDttm',
              width: '150',
              align: 'center'
            },
            {
              label: '调拨出库单单号',
              prop: 'allocationOrderNo',
              width: '240',
              align: 'center'
            },
            {
              label: '收货状态',
              prop: 'receivingStatus',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('dnAllocationOrder.receivingStatus')
            },
            {
              label: '备注',
              prop: 'remarks',
              width: '100',
              align: 'center'
            }
          ],
          param: {auditStatus: 10, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate()},
          url: api.delivery.deliver
        },
        // 详情
        detailColumns: {
          statusOption: {
            prop: 'auditStatus',
            statusImg: {
              10: '/static/un-check.png',
              20: '/static/checked.png',
            },
            right: '100px',
            top: '0px'
          },
          span: 8,
          labelWidth: '130',
          columns: [
            {
              label: '业务单号：',
              prop: 'orderNo',
            }, {
              label: '引用单号：',
              prop: 'allocationOrderNo',
            }, {
              label: '配送门店',
              prop: 'distributionStoreName',
            },
            {
              label: '配送仓库',
              prop: 'distributionWarehouseName',
            },
            {
              label: '收货门店',
              prop: 'receivingStoreName',
            },
            {
              label: '收货仓库',
              prop: 'receivingWarehouseName',
            },
            {
              label: '经手人：',
              prop: 'handlerName',
            }],
          tablesProp: {
            goodsMapMVOList: {
              url: api.delivery.deliverGoods + "/page",
              height: this.detailHeight,
              indexShow: true,
              summaryColumns: ['goodsNum', 'subtotalAmount'],
              tableName: 'goodsMapMVOList',
              showSummary: true,
              columns: [
                {
                  label: '条码',
                  prop: 'goodsBarCode',
                  align: 'center',
                  width: '180'
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  align: 'center',
                  width: '150'
                },
                {
                  label: '规格',
                  prop: 'goodsSpecs',
                  align: 'center',
                  width: '70'
                },
                {
                  label: '单位',
                  prop: 'goodsUnitName',
                  align: 'center',
                  width: '70'
                },
                {
                  label: '类别',
                  prop: 'goodsCategoryName',
                  width: '120',
                  align: 'center',
                },
                {
                  label: '品牌',
                  prop: 'goodsBrandName',
                  align: 'center',
                  width: '120'
                },
                {
                  label: '配送价',
                  prop: 'deliveryPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '数量',
                  prop: 'goodsNum',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '差异数量',
                  width: '100',
                  prop: 'differenceNum',
                  align: 'center',
                },
                {
                  label: '小计金额',
                  prop: 'subtotalAmount',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '当前门店库存',
                  prop: 'goodsInventoryNum',
                  align: 'center',
                  width: '135'
                },
                {
                  label: '零售价',
                  prop: 'retailPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  align: 'center',
                  width: '150'
                }
              ]
            }
          },
          // 打印的列表
          printTablesProp: {
            goodsMapMVOList: {
              summaryColumns: ['goodsNum', 'subtotalAmount'],
              tableName: 'goodsMapMVOList',
              showSummary: true,
              columns: [
                {
                  label: '条码',
                  prop: 'goodsBarCode',
                  align: 'center',
                  width: '180'
                },
                {
                  label: '商品名称',
                  prop: 'goodsName',
                  align: 'center',
                  width: '150'
                },
                {
                  label: '规格',
                  prop: 'goodsSpecs',
                  align: 'center',
                  width: '120'
                },
                {
                  label: '单位',
                  prop: 'goodsUnitName',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '类别',
                  prop: 'goodsCategoryName',
                  width: '120',
                  align: "center"
                },
                {
                  label: '品牌',
                  prop: 'goodsBrandName',
                  align: 'center',
                  width: '120'
                },
                {
                  label: '配送价',
                  prop: 'deliveryPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '数量',
                  prop: 'goodsNum',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '小计金额',
                  prop: 'subtotalAmount',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '当前门店库存',
                  prop: 'goodsInventoryNum',
                  align: 'center',
                  width: '135'
                },
                {
                  label: '零售价',
                  prop: 'retailPrice',
                  align: 'center',
                  width: '100'
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  align: 'center',
                  width: '90'
                }
              ]
            },
          },
          url: api.delivery.deliverDetails
        },
      };
    },
    created(){
      this.$nextTick(() => {
        this.$refs['deliverTemplate'].operationSuccess();
      })
    },
    mounted() {
      if (Object.keys(this.$route.params).length > 0) {
        if (this.$route.params.customQuery) {
          let str = this.$route.params.customQuery
          this.tableOptions.param = eval('(' + str + ')')
        }
      }
      // this.$nextTick(() => {
      //   this.tableOptions.url = api.delivery.deliver
      //   this.$refs['deliverTemplate'].operationSuccess();
      // })
    },
    methods: {
      goOrderDetail(row) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.detailColumns);
        this.$router.push({
          path: '/delivery/deliver/detail?id=' + row.id,
          query: {redirect: '/delivery/deliver'}
        }).catch(err => {
        });
      },
      addRequisition() {
        this.$router.push({path: '/delivery/deliver/add'});
      },
      toEditPage(row) {
        this.$router.push({path: '/delivery/deliver/add?id=' + row.id + '&auditStatus=' + row.auditStatus});
      },
      selectLevel(data) {
        if (data.relateType === 10) {
          this.searchOptions.complex.filter(item => item.prop === 'distributionStoreId')[0].hidden = true;
        } else {
          this.searchOptions.complex.filter(item => item.prop === 'distributionStoreId')[0].hidden = false;
        }
      },
      goodsDetailExport() {
        let selectData = this.$refs["deliverTemplate"].$refs["tableTemp"].selectRow;
        console.log(selectData)
        if (selectData.length === 0) {
          this.$confirm('请选择一条数据！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } else {
          if (selectData.length > 1) {
            this.$confirm('只能选择一条数据！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$refs["deliverTemplate"].$refs["tableTemp"].$refs["clearTable"].clearSelection();
            })
          } else {
            this.$axios.fetchPost(api.delivery.deliverGoodsExport, {
              orderNo: selectData[0].orderNo,
              exportCode: 'DnDistributionGoodsDetailedExport'
            }).then(data => {
              if (data.code === 200) {
                const elink = document.createElement('a');
                elink.href = data.data;
                elink.click();
                this.loadingExt = false;
                this.$notify({
                  type: "success",
                  title: '导出操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: '导出成功', type: 'success'});
              } else {
                this.$notify({
                  type: "error",
                  title: '导出操作',
                  message: '异常',
                  showClose: false,
                });
                // this.$message({message: '导出异常', type: 'error'});
              }
            })
          }
        }
      }

    }
  }
</script>

<style scoped>
  >>> .status-item.item-green {
    background-color: #ed6650;
  }

  >>> .status-item.item-red {
    background-color: #37c186;
  }

</style>



// WEBPACK FOOTER //
// src/page/delivery/Deliver.vue